export default function hours2MinutesFilterFactory() {
  'ngInject';

  return function hours2MinutesFilter(hours = 0) {
    return hours * 60;
  };
}
